import { useEffect, useRef } from "react";
import { Client } from "@stomp/stompjs";
import SockJS from "sockjs-client";
import { Bounce, toast } from "react-toastify";
import { environment } from "../../config/environment";

const ClientNotification = ({ onNotification }) => {
  const clientRef = useRef(null);
  const token = localStorage.getItem("bgc_token");
    const BASE_URL = environment.apiUrl;  // TODO
//   const BASE_URL = "http://localhost:8082";

  useEffect(() => {
    if (!token) {
      return;
    }

    const client = new Client({
      webSocketFactory: () =>
        new SockJS(
          `${BASE_URL}/ws-user?token=${encodeURIComponent("Bearer " + token)}`,
        ),

      reconnectDelay: 5000,

      debug: (msg) => {},

      onConnect: () => {
        client.subscribe("/user/client/notifications", (message) => {
          if (!message?.body) {
            return;
          }

          try {
            const notification = JSON.parse(message.body);

            // Send notification to Dashboard
            if (onNotification) {
              onNotification(notification);
            }

            window.dispatchEvent(
              new CustomEvent("client-notification", {
                detail: notification,
              }),
            );

            toast.info(
              notification.message || "New notification received",

              {
                position: "top-right",
                autoClose: 5000,
                draggable: true,
                theme: "dark",
                transition: Bounce,
              },
            );
            // toast.info(notification.message || "New notification received");
          } catch (err) {}
        });
      },

      onStompError: (frame) => {},

      onWebSocketClose: (event) => {},

      onWebSocketError: (event) => {},
    });

    clientRef.current = client;
    client.activate();

    return () => {
      if (clientRef.current) {
        clientRef.current.deactivate();
      }
    };
  }, [token, onNotification]);

  // This component only listens for notifications
  return null;
};

export default ClientNotification;
